import { useGetCustomStyles, useGetDynamicPages, useGetPortalSummary, useGetStaticPages } from 'api/hooks';
import DefaultBanner from 'assets/defaultImages/GenericBanner.png';
import { ReactComponent as GetStartedIcon } from 'assets/get-started-icon.svg';
import { PageSpec } from 'proto/github.com/solo-io/dev-portal/api/dev-portal/v1beta1/portal_pb';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { CTACard } from './CTACard';
import './HomePage.css';

const CodeIcon: React.FC<{ fillColor?: string }> = ({ fillColor = '#2196c9' }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 33 33' aria-hidden='true'>
      <path
        fill={fillColor}
        d='M1.169 19.456l1.856.413a.067.067 0 01.069.069 15.687 15.687 0 001.444 3.506v.069l-1.031 1.65a1.448 1.448 0 00.206 1.787l2.269 2.269a1.459 1.459 0 001.788.206l1.65-1.031h.069a15.687 15.687 0 003.506 1.444.067.067 0 01.069.069l.413 1.856a1.471 1.471 0 001.444 1.169h3.229a1.53 1.53 0 001.444-1.169l.412-1.856.069-.069a15.687 15.687 0 003.506-1.444l-.344-.619.413.619 1.65 1.031a1.448 1.448 0 001.787-.206l2.269-2.269a1.459 1.459 0 00.206-1.787l-1.031-1.65v-.069a15.687 15.687 0 001.444-3.506.067.067 0 01.069-.069l1.856-.413a1.413 1.413 0 001.1-1.444V14.85a1.484 1.484 0 00-1.1-1.444l-1.925-.413-.069-.069a15.687 15.687 0 00-1.444-3.506V9.35l1.032-1.65a1.459 1.459 0 00-.206-1.788l-2.269-2.268a1.459 1.459 0 00-1.787-.206l-1.65 1.031h-.069a15.687 15.687 0 00-3.506-1.444.067.067 0 01-.069-.069L19.525 1.1A1.413 1.413 0 0018.081 0H14.85a1.548 1.548 0 00-1.444 1.1l-.344 1.856a.067.067 0 01-.069.069 15.687 15.687 0 00-3.506 1.444l.344.619-.413-.55-1.649-1.032a1.459 1.459 0 00-1.788.206L3.712 5.981a1.459 1.459 0 00-.206 1.787l1.031 1.65v.069a15.687 15.687 0 00-1.444 3.506.067.067 0 01-.069.069l-1.856.412A1.471 1.471 0 000 14.919v3.163a1.455 1.455 0 001.169 1.374zm.206-4.606c0-.069 0-.069.069-.069l1.856-.412a1.492 1.492 0 001.1-1.1 10.225 10.225 0 011.306-3.094 1.49 1.49 0 000-1.513l-1.031-1.65v-.137l2.269-2.269h.138l1.65 1.031a1.49 1.49 0 001.513 0 13.473 13.473 0 013.094-1.306 1.492 1.492 0 001.1-1.1l.413-1.856c0-.069 0-.069.069-.069h3.229c.069 0 .069 0 .069.069l.413 1.856a1.521 1.521 0 001.031 1.1 10.225 10.225 0 013.094 1.306 1.49 1.49 0 001.513 0l1.65-1.031h.069l2.269 2.269v.137l-1.031 1.65a1.49 1.49 0 000 1.513 12.309 12.309 0 011.306 3.094 1.315 1.315 0 001.1 1.031l1.856.412a.067.067 0 01.069.069v3.163c0 .069 0 .069-.069.069l-1.856.412a1.521 1.521 0 00-1.1 1.031 10.225 10.225 0 01-1.306 3.094 1.49 1.49 0 000 1.512l1.031 1.65v.138l-2.269 2.269h-.139l-1.65-1.032a1.49 1.49 0 00-1.513 0 13.473 13.473 0 01-3.094 1.306 1.315 1.315 0 00-1.031 1.1l-.412 1.857a.067.067 0 01-.069.069H14.85a.067.067 0 01-.069-.069l-.413-1.856a1.492 1.492 0 00-1.1-1.1 10.225 10.225 0 01-3.094-1.306 1.49 1.49 0 00-1.513 0l-1.65 1.031h-.067L4.675 25.85v-.138l1.031-1.65a1.49 1.49 0 000-1.512A12.309 12.309 0 014.4 19.456a1.315 1.315 0 00-1.1-1.031l-1.856-.412c-.069.069-.069.069-.069 0z'
      />
      <path
        fill={fillColor}
        d='M16.5 26.168a9.735 9.735 0 10-9.737-9.734 9.736 9.736 0 009.737 9.734zm0-18.016a8.282 8.282 0 11-8.284 8.282A8.279 8.279 0 0116.5 8.152z'
      />
      <path
        fill={fillColor}
        d='M14.905 20.067a.633.633 0 00.829-.319l2.68-6.127a.628.628 0 10-1.148-.51l-2.68 6.125a.633.633 0 00.319.831zM20.39 18.306l-1.34 1.085a.633.633 0 00.829.957l1.978-1.6a.788.788 0 00.255-.51.58.58 0 00-.255-.51l-1.978-1.6a.678.678 0 00-.893.064.769.769 0 00.064 1.021zM13.19 16.662a.633.633 0 00.829-.957l-1.34-1.085 1.34-1.085a.633.633 0 10-.829-.957l-1.978 1.6a.788.788 0 00-.255.51.58.58 0 00.255.51z'
      />
    </svg>
  );
};

export const HomePage = () => {
  const history = useHistory();
  const { customStyles, customStylesError } = useGetCustomStyles();
  const { staticPages, staticPagesError } = useGetStaticPages();
  const { portalSummary, portalSummaryError } = useGetPortalSummary();
  const { dynamicPages, dynamicPagesError } = useGetDynamicPages();
  const [displayedPage, setDisplayedPage] = React.useState<PageSpec.AsObject>();

  React.useEffect(() => {
    document.title = portalSummary?.displayName ?? 'Portal';
  }, [portalSummary?.displayName]);

  React.useEffect(() => {
    if (!!staticPages || !!dynamicPages) {
      setDisplayedPage([...(staticPages ?? []), ...(dynamicPages ?? [])].find(page => !!page.displayOnHomepage));
    }
  }, [staticPages?.length, dynamicPages?.length]);

  const goToFirstPage = () => {
    history.push({
      pathname: displayedPage?.path || '/apis/'
    });
  };

  const goToApis = () => {
    history.push({
      pathname: '/apis/'
    });
  };

  return (
    <main className='home-page-container'>
      <>
        {!!customStyles?.bannerUrl ? (
          <img className='home-page-background-image-holder' src={customStyles?.bannerUrl || DefaultBanner} alt={''} />
        ) : (
          <img className='home-page-background-image-holder' src={DefaultBanner} alt={''} />
        )}
        <div className='home-page-background-image-holder-overlay' />
      </>
      <div className='home-page-portal-header'>
        <h1 className='home-page-portal-title  font-normal text-white'>
          {portalSummary?.displayName || 'Gloo Portal'}
        </h1>
        <div className='home-page-portal-description'>{portalSummary?.description || ''}</div>
      </div>
      {/* TODO: (ascampos) apply in css sheet */}
      <div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
        <CTACard
          data-testid='cta-view-apis'
          title='APIs'
          icon={<CodeIcon fillColor={customStyles?.customStyling?.primaryColor} />}
          content='Browse the list of APIs and documentation in this portal. From here you can get the information you need to make API calls.'
          ctaText='View APIs'
          onCTAClick={goToApis}
        />
        {!!displayedPage && (
          <CTACard
            title={displayedPage.name}
            icon={<GetStartedIcon title='' />}
            content={displayedPage.description}
            ctaText='Read More'
            onCTAClick={goToFirstPage}
            notReady={!staticPages && !dynamicPages}
          />
        )}
      </div>
    </main>
  );
};
